<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <template v-slot:activator="{ on }">
        <v-btn block
          color="primary"
          @click="openVideo"
          :disabled="loading"
          :loading="loading">
          <v-icon>play_circle_outline</v-icon>{{btnTitle}}
        </v-btn>
      </template>
      <v-card class="justify-center">
        <img class="align-center" src="@/assets/logo.jpg" alt="">
          <v-btn class="align-center-btn" width="300px" @click="$emit('openVideo');dialog = false;">Ver desde el inicio</v-btn>
          <v-btn
            class="align-center-btn"
            width="300px"
            color="primary"
            @click="$emit('openVideoFromTimestamp');dialog = false;">Ver desde {{timestamp}}</v-btn>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
  import { mapActions } from 'vuex'
  export default {
    data () {
      return {
        dialog: false,
        loading: false,
      }
    },
    props: {
      btnTitle: String,
      watching: Object
    },
    computed: {
      timestamp () {
        return new Date(((this.watching || {}).timestamp || 0) * 1000).toISOString().substr(11, 8)
      }
    },
    methods: {
      ...mapActions(['checkSubscription', 'checkActiveUser']),
      async openVideo () {
        const isMobile = /iPhone|iPad|iPod/i.test(navigator.userAgent)
        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) && !isMobile;

        if (isSafari) {
          return this.$router.push({ name: 'IncompatibilityDesktop' })
        }

        if(/webOS|iPhone|iPad|iPod|Opera Mini/i.test(navigator.userAgent)) {
          return this.$router.push({ name: 'Incompatibility' })
        }
        this.loading = true
        const status = await this.checkSubscription()
        if (status === 'pending') await this.checkSubscription()
        this.loading = false
        if (this.watching && this.watching.timestamp > 5) {
          this.$emit('openVideoFromTimestamp')
          this.dialog = false
          return false
        } else {
          this.$emit('openVideo')
          this.dialog = false
          return false
        }
      }
    }
  }
</script>

<style scoped>
  .align-center {
    margin-top: 10%;
    margin-left: calc(50% - 165px);
  }
  .align-center-btn {
    display: block;
    margin-left: calc(50% - 82px);
  }
</style>
<style>
  .align-center-btn * {
    width: 135px;
  }
</style>